// Constants for different requests for current reducer
export default {
  codes: 'CODES',
};
